module.exports = __webpack_public_path__ + "static/img/essential1-new.af3a7eec.png";